import React from 'react';
import { Facebook, Instagram } from 'lucide-react';
import { Button } from '../ui/Button';
export function SocialProof() {
  return <section className="py-20 bg-gray-50" data-id="element-74">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-75">
        <h2 className="text-3xl font-bold text-gray-900 mb-6" data-id="element-76">
          Join Our Thriving Community
        </h2>
        <p className="text-lg text-gray-600 mb-12 max-w-2xl mx-auto" data-id="element-77">
          See what our students and families are up to. Follow us on social
          media for daily inspiration, class updates, and student achievements.
        </p>

        <div className="flex flex-col sm:flex-row justify-center gap-6" data-id="element-78">
          <a href="https://www.facebook.com/Limitlessmartialart/" target="_blank" rel="noopener noreferrer" className="flex-1 max-w-sm" data-id="element-79">
            <div className="bg-white p-8 rounded-xl shadow-sm border border-gray-100 hover:shadow-md transition-all group h-full" data-id="element-80">
              <div className="w-16 h-16 bg-[#1877F2]/10 rounded-full flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform" data-id="element-81">
                <Facebook className="w-8 h-8 text-[#1877F2]" data-id="element-82" />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-83">Facebook</h3>
              <p className="text-gray-500 mb-6" data-id="element-84">
                Connect with our community and see latest updates.
              </p>
              <span className="text-[#1877F2] font-medium group-hover:underline" data-id="element-85">
                Follow Page →
              </span>
            </div>
          </a>

          <a href="https://instagram.com/LimitlessMA" target="_blank" rel="noopener noreferrer" className="flex-1 max-w-sm" data-id="element-86">
            <div className="bg-white p-8 rounded-xl shadow-sm border border-gray-100 hover:shadow-md transition-all group h-full" data-id="element-87">
              <div className="w-16 h-16 bg-[#E4405F]/10 rounded-full flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform" data-id="element-88">
                <Instagram className="w-8 h-8 text-[#E4405F]" data-id="element-89" />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-90">
                Instagram
              </h3>
              <p className="text-gray-500 mb-6" data-id="element-91">
                See photos of our classes, events, and student success.
              </p>
              <span className="text-[#E4405F] font-medium group-hover:underline" data-id="element-92">
                Follow Us →
              </span>
            </div>
          </a>
        </div>
      </div>
    </section>;
}